export default __webpack_public_path__ + "static/media/Error404.26124fde.png";